module.exports = __webpack_public_path__ + "img/order-3.dd5656de.jpg";